<template>
  <v-container fluid>
    <v-skeleton-loader
      type="table-heading, list-item-two-line, list-item-three-line, article"
    />
  </v-container>
</template>

<script lang="ts" setup></script>
